import {
	createPageSegmentLoadMetric,
	OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY,
} from '@confluence/browser-metrics';

export const OBJECT_SIDEBAR_CONTROL_METRIC = createPageSegmentLoadMetric({
	key: OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY,
	ssr: Boolean(window.__SSR_RENDERED__) ? { doneAsFmp: true } : undefined,
});
